export default __webpack_public_path__ + "static/media/appstore.1a007043.png";